<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>STEP<span>06</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>WEBサイトのURL設定</span></h3>
            </div>

            <!--item-->
            <div class="item-wrap">
                <div class="item form_text">
                    <input type="url" id="your-website-url" placeholder=" " value="">
                    <label for="your-website-url" class="m-label"><span>URL</span></label>
                </div>
                <p class="md_annotation"><span>http:// または https:// からご記入ください</span></p>
            </div>
        </div>

        <div class="control-wrap">
            <button type="button" class="_left js-swiper-prev"><span>Back</span></button>
            <button type="button" class="_right js-swiper-next"><span>Next</span></button>
        </div>

    </div>
</div>
</template>

